namespace $.$$ {

	export class $shm_tests_visual extends $.$shm_tests_visual {

		data() {
			return this.comparison() as $shm_tests_visual_comparison | null
		}

		comparison_title() {
			const data = this.data()
			return data ? `${ data.key } · ${ data.profile }` : 'Скриншот'
		}

		comparison_status() {
			switch( this.data()?.status ) {
				case 'unchanged': return '✓ Совпадает'
				case 'changed': return '✕ Изменён'
				case 'size_changed': return '✕ Изменён размер'
				case 'missing_baseline': return '○ Нет эталона'
				case 'updated': return '✓ Эталон обновлён'
				case 'error': return '⚠ Ошибка сравнения'
				default: return ''
			}
		}

		comparison_metrics() {
			const data = this.data()
			if( !data ) return ''
			const ratio = data.changed_ratio === undefined ? '' : `Изменено: ${ ( data.changed_ratio * 100 ).toFixed( 3 ) }% (${ data.changed_pixels ?? 0 } пикс.)`
			const dimensions = data.dimensions
				? `Размер: ${ data.dimensions.expected.width }×${ data.dimensions.expected.height } → ${ data.dimensions.actual.width }×${ data.dimensions.actual.height }`
				: ''
			const bounds = data.bounds
				? `Область: ${ data.bounds.left },${ data.bounds.top } — ${ data.bounds.right },${ data.bounds.bottom }`
				: ''
			const threshold = data.threshold === undefined
				? ''
				: `Порог: ${ data.threshold } · допустимо ${ ( ( data.max_diff_ratio ?? 0 ) * 100 ).toFixed( 3 ) }%`
			return [ ratio, dimensions, bounds, threshold ].filter( Boolean ).join( '\n\n' )
		}

		image_rows() {
			return [ 'expected', 'actual', 'diff' ].filter( id => this.image_path( id ) ).map( id => this.Image( id ) )
		}

		image_path( id: string ) {
			const data = this.data()
			if( !data ) return ''
			return String( data[ id as 'expected' | 'actual' | 'diff' ] || '' )
		}

		image_title( id: string ) {
			return { expected: 'Эталон', actual: 'Новый', diff: 'Diff' }[ id ] ?? id
		}

		image_uri( id: string ) {
			const imagePath = this.image_path( id )
			if( !imagePath ) return ''
			return new URL(
				imagePath.replace( /\\/g, '/' ),
				new URL( this.manifest_uri(), this.$.$mol_dom_context.location.href ),
			).toString()
		}

	}

}
